import { TokenContract } from '@/contract/func/token'
import { ethers } from 'ethers'
import { markRaw } from 'vue'
import { Module } from 'vuex'

interface State {
  contract: TokenContract | null
  balance: ethers.BigNumberish
  allowance: ethers.BigNumberish
  info: {
    symbol: string,
    decimal: number
  }
}

export const store = {
  namespaced: true,
  state: () => ({
    contract: null,
    balance: '0',
    allowance: '0',
    info: {
      symbol: '',
      decimal: 0
    }
  }),
  getters: {},
  mutations: {
    INIT_CONTRACT (state, contract: TokenContract) {
      state.contract = markRaw(contract)
    },

    SET_BALANCE (state, balance: ethers.BigNumberish) {
      state.balance = balance
    },

    SET_INFO (state, info: Partial<State['info']>) {
      info.decimal && (state.info.decimal = info.decimal)
      info.symbol && (state.info.symbol = info.symbol)
    },

    SET_ALLOWANCE (state, allowance: ethers.BigNumberish) {
      state.allowance = allowance
    }
  },
  actions: {
    async init ({ commit, dispatch }, payload: {
      address: string
      rpc: string
      account: string
    }) {
      console.log(payload.address, payload.rpc)

      const contract = new TokenContract(payload.address, payload.rpc)

      console.log('init', contract)

      commit('INIT_CONTRACT', contract)

      await Promise.all([
        dispatch('info'),
        dispatch('getBalance', payload.account)
      ])

      dispatch('pollBalance', payload.account)
    },

    async info ({ state, commit }) {
      if (!state.contract) return

      const [decimal, symbol] = await Promise.all([
        state.contract.contract.decimals(),
        state.contract.contract.symbol()
      ])

      commit('SET_INFO', {
        decimal,
        symbol
      } as Partial<State['info']>)
    },

    async getBalance ({ state, commit }, account: string) {
      if (!state.contract) return

      console.log('getBalance', state.contract, account)

      const data = await state.contract.contract.balanceOf(account)

      commit('SET_BALANCE', data.toString())
    },

    pollBalance ({ dispatch }, account: string) {
      setTimeout(() => {
        dispatch('pollBalance', account)
      }, 5000)
    },

    async allowance ({ state, commit }, payload: {
      owner: string
      spender: string
    }) {
      if (!state.contract) return

      const data = await state.contract.contract.allowance(payload.owner, payload.spender)

      commit('SET_ALLOWANCE', data.toString())

      return data
    }
  }
} as Module<State, any>
